import { render, staticRenderFns } from "./productIntroduce.vue?vue&type=template&id=fdea4902&scoped=true&"
import script from "./productIntroduce.vue?vue&type=script&lang=js&"
export * from "./productIntroduce.vue?vue&type=script&lang=js&"
import style0 from "./productIntroduce.vue?vue&type=style&index=0&id=fdea4902&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fdea4902",
  null
  
)

export default component.exports